module.exports = __webpack_public_path__ + "gq.svg?12d5546c52e30b09fcc94cf45221ff12";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gq.svg
// module id = 1070
// module chunks = 27